import { Stack, Typography, Box } from "@mui/material";
import { TbShoppingCartX } from "react-icons/tb";

export default function NoOrderFound() {
    return (
        <Stack
            height="100%"
            alignItems="center"
            justifyContent="center"
            spacing={1.5}
            sx={{
                py: 6,
                color: "text.secondary",
            }}
        >
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    backgroundColor: '#f1f1f1',

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <TbShoppingCartX
                    size={42}
                    style={{
                        color: '#9b9b9b',
                    }}
                />
            </Box>

            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: 15,
                    color: "#555",
                }}
            >
                No orders found
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    color: "#999",
                    textAlign: "center",
                    maxWidth: 280,
                }}
            >
                This customer does not have any recorded orders yet.
            </Typography>
        </Stack>
    );
}